import Vue from "vue";
import App from "./App.vue";
import store from "./store";
//qs 配合axios使用
import qs from "qs";
//日期时间格式化插件
import moment from "moment";
// 导入路由配置
import router from "./router/router.js";
//  导入配置后的axios与api, 注入到Vue的原型当中, 使可以通过this调用
import axios from "./js/axios_config.js";
import api, { domain } from "./js/api_config.js";
//导入工具类
import utils from "./js/utils.js";
//导入md5加密
import md5 from "js-md5";
//导入无限滚动工具
import infiniteScroll from "vue-infinite-scroll";
Vue.use(infiniteScroll);

import * as enumerate from "./js/enumerate.js";

import VueClipBoard from "vue-clipboard2";

// 指令
import * as directives from "./directives/index";

// 引入 fastclick 解决点击延迟300毫秒问题
import fastClick from "fastclick";
fastClick.attach(document.body);

import "./style/iconfont.css";

//vantui框架
import Vant from "vant";
import "vant/lib/index.less";
import "./style/base.less";
import "tailwindcss/tailwind.css";

//postcss-pxtorem 是一款 postcss 插件，用于将单位转化为 rem
//lib-flexible 用于设置 rem 基准值
import "lib-flexible/flexible.js";

// import { ExceptionlessClient } from 'exceptionless/dist/exceptionless';
// const excepConfig = {
//     apiKey: "dyhdsJJimUAUQHXRBKCMSzmZ7FdpMIenr63mLK3R",
//     serverUrl: "//api.log.busboss.cn"
// };
window.ver = "2026-06-23.1";
// window._exceptionlessClient = new ExceptionlessClient(excepConfig);
// window._exceptionlessClient.config.setVersion(window.ver);
// window._exceptionlessClient.config.useReferenceIds() // 引用参考号
// 如果是本地，则禁用日志收集
// if (window.location.hostname === 'localhost') {
//     window._exceptionlessClient.config.enabled = false
// }
// window._exceptionlessClient.config.useDebugLogger();

// import VUEAMap from 'vue-amap';
// Vue.use(VUEAMap);
// // 初始化vue-amap
// VUEAMap.initAMapApiLoader({
//     // 高德的key
//     key: '13c3c2b4b14658ea983e9629219a040e',
//     // 插件集合 （插件按需引入）
//     plugin: ['AMap.Geolocation', 'AMap.Scale']
// });

//sm加密公钥
window._UserSm2PublicKey =
  "03e34eced2195e8da875a15d22b968e873db6cc86803289c61c84bda1c1d67d83e";

Vue.use(moment);
Vue.use(Vant);

Vue.prototype.$http = axios;
Vue.prototype.$domain = domain;
Vue.prototype.$api = api;
Vue.prototype.$qs = qs;
Vue.prototype.$utils = utils;
Vue.prototype.$md5 = md5;
Vue.prototype.$moment = moment;
Vue.prototype.$enum = enumerate;

Vue.use(VueClipBoard);

Vue.config.productionTip = false;
Vue.filter("dateToFormat", function (date) {
  return moment(date).format("YYYY-MM-DD HH:mm:ss");
});
Vue.filter("dateToStr", function (classDate) {
  if (!classDate) {
    return "";
  }
  classDate = moment(classDate).format("YYYY-MM-DD");
  var note = "";
  if (classDate == moment().format("YYYY-MM-DD")) {
    note = " 今天";
  } else if (
    classDate ==
    moment()
      .add(1, "d")
      .format("YYYY-MM-DD")
  ) {
    note = " 明天";
  } else if (
    classDate ==
    moment()
      .add(-1, "d")
      .format("YYYY-MM-DD")
  ) {
    note = " 昨天";
  } else if (
    classDate ==
    moment()
      .add(-2, "d")
      .format("YYYY-MM-DD")
  ) {
    note = " 前天";
  } else if (
    classDate ==
    moment()
      .add(2, "d")
      .format("YYYY-MM-DD")
  ) {
    note = " 后天";
  } else {
    var n = moment(classDate).day();
    switch (n) {
      case 0:
        note = " 周日";
        break;
      case 1:
        note = " 周一";
        break;
      case 2:
        note = " 周二";
        break;
      case 3:
        note = " 周三";
        break;
      case 4:
        note = " 周四";
        break;
      case 5:
        note = " 周五";
        break;
      case 6:
        note = " 周六";
        break;
    }
  }
  return moment(classDate).format("MM月DD日") + note;
});

// 指令
Object.keys(directives).forEach((item) => {
  Vue.directive(item, directives[item]);
});

Vue.config.errorHandler = function (err, vm, info) {
  window._exceptionlessClient.createException(err).submit();
  console.error("error---", err);
  console.info("vm---", vm);
  console.info("info---", info);
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
